import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatBold = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M9.5 10c2.278 0 4.25-1.847 4.25-4.125S11.778 1.75 9.5 1.75H5.75a1 1 0 0 0-1 1V10m4.75 0H11c2.278 0 4.25 1.847 4.25 4.125S13.278 18.25 11 18.25H5.75a1 1 0 0 1-1-1V10m4.75 0H4.75"
	})]
});
const ForwardRef = forwardRef(SvgFormatBold);
export { ForwardRef as ReactComponent };
